import { useLocation } from 'react-router-dom'

export function useIsFarmsPage() {
  const { pathname } = useLocation()
  return pathname.startsWith('/farm')
}
